import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useEffect } from "react";
import _ from "lodash";
const PowerPicker = ({ powers, onSelect }) => {
  useEffect(() => {
    if (powers.length === 1) {
      onSelect(powers[0]);
    }
  }, [powers]);

  return (
    <List sx={{ pt: 0 }}>
      {_(powers)
        .orderBy("power")
        .map((power, index) => {
        const { power: powerValue, unit } = power;
        return (
          <ListItem disableGutters key={index}>
            <ListItemButton onClick={() => onSelect(power)}>
              <ListItemText primary={`${powerValue} ${unit}`} />
            </ListItemButton>
          </ListItem>
        );
      })
      .value()}
    </List>
  );
};

export default PowerPicker;